// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-cards__container {
    margin-top: calc( var( --space-x2 ) + var( --space-eighth ) );
}

.league-match-cards__score.baloa-headline-2 {
    color: var( --primary-dark-color );
    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);
}



.league-match-cards__cointainer__info-players__column {
    width: calc(calc(100% - 24px)/2);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

/* .league-match-cards__cointainer__info-players__column:first-of-type {
    margin-right: calc( var( --space-x3 ) + var( --space-half-quarter ));
}

.league-match-cards__cointainer__info-players__column:last-of-type {
    margin-left: calc( var( --space-x3 ) + var( --space-half-quarter ));
}
 */
.league-match-cards__cointainer__action-btn {
    display: flex;
    justify-content: flex-start;
    margin: 10px 16px;
}

.league-match-cards__contianer__info-players {
    display: flex;
    margin: 0 var( --space-x2 );
    flex-wrap: wrap;
    gap: 24px;
}

.league-match-cards__cointainer__info-players__column-title {
    width: 100%;
}

.league-match-cards__cointainer__info-players__column-title .baloa-table{
    color: var(--primary-very-dark-color);
}

.league-match-cards__cointainer__input-player {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.league-match-cards__cointainer__input-player .MuiAutocomplete-hasClearIcon {
    margin-right: var( --space );
}

.league-match-cards__cointainer__input-player_inputautocomplete{
    width: 100%;
}

.league-match-cards__remove-card {
    height: 24px;
    background-color: var( --new-gray-background-color );
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    transform: translate(8px, -44px);
    margin: 0 12px;
}

.league-match-cards__cointainer__input-card {
    display: flex;
    align-items: center;
    justify-content: center;
}

.league-match-cards__cointainer__cards_input {
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    border-radius: 8px;
    padding: 30px 12px 12px 12px;
    margin-bottom: 8px;
}

.league-match-cards__container_column_inf-team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: var(--space) var(--space-and-half);
}

.league-match-cards__cointainer__players {
    background: var(--new-background-color);
    min-height: 300px;
    border-radius: 8px;
    margin: 0 7px 16px 7px;
    padding: 8px;
    height: 300px;
}

.league-match-cards__cointainer__info-players__empty-message.baloa-table{
    text-align: center;
    padding-top: 20%;
    color: var(--basic-gray-color);
}

.league-match-cards__column_inf-team{
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 12px;
}

.league-match-cards__column_inf-team_photo {
    width:28px;
    border-radius: 50%;
}

.league-match-cards__column_inf-team .icon-ball{
    color: var(--white-color );
    font-size: 24px;
    border-radius: 50%;
    padding: 3px;
}

.league-match-cards__column_inf-team-name .baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.league-match-cards__column_inf-team-name .baloa-mini{
    color: var(--primary-dark-color);
}

.league-match-cards-form__form__minute-input.minute-input {
    margin: 0;
}

.league-match-cards-form__form__minute-input.minute-input .MuiInputBase-root {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-match-cards__cointainer__input-player .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {
   border-radius: 8px;
}

.league-match-cards__cointainer__input-player .search_members_staff_edit_content .input-field-autocomplete label{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    font-size: 14px;
}

.league-match-cards-form__form__minute-input.minute-input .form-minute-input label{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-cards/LeagueMatchCardsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;AACjE;;AAEA;IACI,kCAAkC;IAClC,+DAA+D;AACnE;;;;AAIA;IACI,gCAAgC;IAChC,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;;;;;;;EAOE;AACF;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kDAAkD;IAClD,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;IACzD,2CAA2C;AAC/C;;AAEA;IACI,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;GACG,kBAAkB;AACrB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;AACnB","sourcesContent":[".league-match-cards__container {\n    margin-top: calc( var( --space-x2 ) + var( --space-eighth ) );\n}\n\n.league-match-cards__score.baloa-headline-2 {\n    color: var( --primary-dark-color );\n    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);\n}\n\n\n\n.league-match-cards__cointainer__info-players__column {\n    width: calc(calc(100% - 24px)/2);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n/* .league-match-cards__cointainer__info-players__column:first-of-type {\n    margin-right: calc( var( --space-x3 ) + var( --space-half-quarter ));\n}\n\n.league-match-cards__cointainer__info-players__column:last-of-type {\n    margin-left: calc( var( --space-x3 ) + var( --space-half-quarter ));\n}\n */\n.league-match-cards__cointainer__action-btn {\n    display: flex;\n    justify-content: flex-start;\n    margin: 10px 16px;\n}\n\n.league-match-cards__contianer__info-players {\n    display: flex;\n    margin: 0 var( --space-x2 );\n    flex-wrap: wrap;\n    gap: 24px;\n}\n\n.league-match-cards__cointainer__info-players__column-title {\n    width: 100%;\n}\n\n.league-match-cards__cointainer__info-players__column-title .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-cards__cointainer__input-player {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.league-match-cards__cointainer__input-player .MuiAutocomplete-hasClearIcon {\n    margin-right: var( --space );\n}\n\n.league-match-cards__cointainer__input-player_inputautocomplete{\n    width: 100%;\n}\n\n.league-match-cards__remove-card {\n    height: 24px;\n    background-color: var( --new-gray-background-color );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    cursor: pointer;\n    width: 32px;\n    transform: translate(8px, -44px);\n    margin: 0 12px;\n}\n\n.league-match-cards__cointainer__input-card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.league-match-cards__cointainer__cards_input {\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    border-radius: 8px;\n    padding: 30px 12px 12px 12px;\n    margin-bottom: 8px;\n}\n\n.league-match-cards__container_column_inf-team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: var(--space) var(--space-and-half);\n}\n\n.league-match-cards__cointainer__players {\n    background: var(--new-background-color);\n    min-height: 300px;\n    border-radius: 8px;\n    margin: 0 7px 16px 7px;\n    padding: 8px;\n    height: 300px;\n}\n\n.league-match-cards__cointainer__info-players__empty-message.baloa-table{\n    text-align: center;\n    padding-top: 20%;\n    color: var(--basic-gray-color);\n}\n\n.league-match-cards__column_inf-team{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: 12px;\n}\n\n.league-match-cards__column_inf-team_photo {\n    width:28px;\n    border-radius: 50%;\n}\n\n.league-match-cards__column_inf-team .icon-ball{\n    color: var(--white-color );\n    font-size: 24px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league-match-cards__column_inf-team-name .baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.league-match-cards__column_inf-team-name .baloa-mini{\n    color: var(--primary-dark-color);\n}\n\n.league-match-cards-form__form__minute-input.minute-input {\n    margin: 0;\n}\n\n.league-match-cards-form__form__minute-input.minute-input .MuiInputBase-root {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-match-cards__cointainer__input-player .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {\n   border-radius: 8px;\n}\n\n.league-match-cards__cointainer__input-player .search_members_staff_edit_content .input-field-autocomplete label{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    font-size: 14px;\n}\n\n.league-match-cards-form__form__minute-input.minute-input .form-minute-input label{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
